<template>
    <div class="table-responsive">
      <div class="row">
        <div class="col-3">
        </div>
        <div class="col-6"></div>
        <div class="col-3 pr-4">
          <label for="">Search</label>
          <div class="has-search">
            <span class="fa fa-search form-control-feedback"></span>
            <input v-model="searched" placeholder="Search..." v-on:input="search" type="text"
              style="background-color: #edf2f5" class="form-control" />
          </div>
        </div>
      </div>
      <!-- <div v-if="isLoading" id="loader"></div> -->
      <table class="table table-hover mt-2" id="dataTable" width="100%" cellspacing="0">
        <thead>
          <tr>
            <th id="title">Title</th>
            <!-- <th>Views</th> -->
            <th>Published</th>
            <th>Featured</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr  v-if="isLoader" id="table_row" >
            <td colspan="16">
              <b-skeleton-wrapper >
                  <b-skeleton height="40px" ></b-skeleton>   
                  <b-skeleton height="40px"></b-skeleton>  
                  <b-skeleton height="40px"></b-skeleton>                                     
              </b-skeleton-wrapper> 
            </td>
          </tr>
          <row v-show="!isLoader" v-for="webinar in webinars" :webinar="webinar" :key="webinars.id" :pageNumber="currentPage"></row>
        </tbody>
      </table>
      <h5 style="text-align: center; margin-top:2rem;" v-if="webinars.length < 1 && !isLoader">No Record found.</h5>
      <paginate  v-if="!isLoader" v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''"
        :first-button-text="''" :last-button-text="''" :first-last-button="true"
        :container-class="'pagination pagination-sm float-right mr-3'" :page-class="'page-item'"
        :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'"
        :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
    </div>
  </template>
  
  <script>
    import row from "./row";
    import Multiselect from "vue-multiselect";
    export default {
      name: "FAQTable",
      components: {
        Multiselect,
        "row": row,
      },
      props: ["webinars", "totalPages", "page", "setSkeletonLoader"],
      data: function () {
        return {
          searched: "",
          isLoading: false,
          isLoader: true,
        };
      },
      mounted:function(){
        this.showskLoader = this.setSkeletonLoader;
        this.isLoader=this.showskLoader;
      },

      computed: {
        currentPage: {
          get: function () {
            return this.page;
          },
          set: function () {},
        },
        showskLoader: {
          get:function(){
            return this.setSkeletonLoader
          },
          set: function (val) {
            this.isLoader = val;
            return val;
           },
        },
      },
      watch:{
        showskLoader: function (val) {
          this.isLoader = val;
          return val;
        },

       } ,
      methods: {
        setPage(page) {
          this.$emit("setPage", page);
        },
        search() {
          this.$emit("setSearch", this.searched);
        },
      },
    };
  </script>
  <style>
    #loader {
      position: absolute;
      left: 50%;
      top: 50%;
      z-index: 1;
      margin: -75px 0 0 -75px;
      border: 16px solid #f3f3f3;
      border-radius: 50%;
      border-top: 16px solid #3498db;
      width: 120px;
      height: 120px;
      -webkit-animation: spin 2s linear infinite;
      animation: spin 2s linear infinite;
    }
  
    /* Safari */
    @-webkit-keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
      }
  
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
  
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
  
      100% {
        transform: rotate(360deg);
      }
    }
  
    /* tbody td:nth-child(1){
      width: 50%;
    }
    tbody td:nth-child(2){
      width: 20%;
    }
    tbody td:nth-child(3){
      width: 15%;
    }
    tbody td:nth-child(4){
      width: 15%;
    } */
  </style>
  
  <style scoped>
    #title {
      text-align: left !important;
      padding-left: 40px;
    }
  </style>